import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import Industries from "@/pages/Industries";
export const Route = createFileRoute("/industries/")({ head: ({match}) => pageHead(match.pathname), component: () => (<Industries />) });
